/* THIS FILE IS GENERATED. DO NOT EDIT */
// @ts-ignore
            
import * as Types from '@generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSubscriptionOverviewQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type GetSubscriptionOverviewQuery = { __typename?: 'Root', organization?: { __typename?: 'Organization', id?: string | null, chargeSystems?: Array<{ __typename?: 'ChargeSystem', id: string, connectors?: Array<{ __typename?: 'Connector', id: string, sim?: boolean | null }> | null }> | null, subscription?: { __typename?: 'Subscription', subscriptionId?: number | null, startDate?: string | null, endDate?: string | null, nextInvoiceDate?: string | null, billingPeriod?: Types.BillingPeriod | null, organizationId?: string | null, subscriptionLines?: Array<{ __typename?: 'SubscriptionLine', paidConnectors?: number | null, activeConnectors?: Array<string | null> | null, product?: { __typename?: 'SubscriptionProduct', productId: string, productName: string, productCategory: string, baseSubscriptionProduct?: boolean | null, productPrice: { __typename?: 'SubscriptionProductPrice', productPriceId: string, price: number, priceInclVAT: number, billingPeriod: number, currency: string, validFrom: string, validTo?: string | null } } | null }> | null } | null } | null };


export const GetSubscriptionOverviewDocument = gql`
    query GetSubscriptionOverview($id: ID!) {
  organization(id: $id) {
    id
    chargeSystems {
      id
      connectors {
        id
        sim
      }
    }
    subscription {
      subscriptionId
      startDate
      endDate
      nextInvoiceDate
      billingPeriod
      organizationId
      subscriptionLines {
        paidConnectors
        activeConnectors
        product {
          productId
          productName
          productCategory
          baseSubscriptionProduct
          productPrice {
            productPriceId
            price
            priceInclVAT
            billingPeriod
            currency
            validFrom
            validTo
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetSubscriptionOverviewQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetSubscriptionOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionOverviewQuery, GetSubscriptionOverviewQueryVariables> & ({ variables: GetSubscriptionOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionOverviewQuery, GetSubscriptionOverviewQueryVariables>(GetSubscriptionOverviewDocument, options);
      }
export function useGetSubscriptionOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionOverviewQuery, GetSubscriptionOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionOverviewQuery, GetSubscriptionOverviewQueryVariables>(GetSubscriptionOverviewDocument, options);
        }
export function useGetSubscriptionOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionOverviewQuery, GetSubscriptionOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionOverviewQuery, GetSubscriptionOverviewQueryVariables>(GetSubscriptionOverviewDocument, options);
        }
export type GetSubscriptionOverviewQueryHookResult = ReturnType<typeof useGetSubscriptionOverviewQuery>;
export type GetSubscriptionOverviewLazyQueryHookResult = ReturnType<typeof useGetSubscriptionOverviewLazyQuery>;
export type GetSubscriptionOverviewSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionOverviewSuspenseQuery>;
export type GetSubscriptionOverviewQueryResult = Apollo.QueryResult<GetSubscriptionOverviewQuery, GetSubscriptionOverviewQueryVariables>;